import { CommissionRules } from '../modules/sales/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanyCommissionRulesScreen() {
  const { can, company } = useCompanyScope();
  const activeUnit = (company.businessUnits ?? []).find(
    (unit) => unit.id === company.activeBusinessUnitId,
  );
  return (
    <GatedCompanyScreen allowed={can('sales.commissions.manage')}>
      {/* As regras são da empresa; a consulta do profissional é ajuste de estabelecimento. */}
      <CommissionRules showsUnitSetting={activeUnit?.kind !== 'SUPPORT'} />
    </GatedCompanyScreen>
  );
}
